import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import * as types from "../../constants/actionTypes";
import { messages, success, deleteData } from "../../components/messageBox";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";
import { setLoader } from "./actions";

const getStateDashboard = (state) => state.Dashboard;

export function* getListKonsultasi(params) {
  try {
    yield put(setLoader(true));

    const _userData = JSON.parse(localStorage.getItem("UserData"));

    const _body = {
      id: _userData.f_id_klinik,
      id_poli: _userData.f_id_poli,
      id_dokter: _userData.f_id_dokter,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DASHBARD_DOKTER_LIST_KONSULTASI_POST, _body, { headers: Header() });

    if (response.acknowledge == 1) {
      yield put({ type: types.GET_LIST_KONSULTASI_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(types.GET_LIST_KONSULTASI, getListKonsultasi)]);
}
